import LotService from '@/api/LotService'

export const transformBins = (input = []) => {
  return input.map((item) => {
    return {
      'id': item._id,
      'code': item.code,
    }
  })
}

export const transformLot = (input = {}) => {
  return {
    'stockId': input.stock_id,
    'skuId': input.sku_id,
    'productId': input.product_id,
    'whId': input.wh_id,
    'binLocationId': input.bin_location_id,
    'shopId': input.shop_id,
    'grId': input.gr_id,
    'poId': input.po_id,
    'dateIn': input.date_in,
    'dateProduct': input.date_product,
    'dateExpire': input.date_expire,
    'unitInit': input.unit_init,
    'unitBalance': input.unit_balance,
    'cost': input.cost,
    'note': input.note,
    'isReady': input.is_ready,
    'lotCode': input.lot_code,
    'createdBy': input.created_by,
    'createdAt': input.created_at,
    'sku': {
      'config': {
        'inventory': {
          'useLot': input.sku && input.sku.config && input.sku.config.inventory.use_lot || false,
          'useSerial': input.sku && input.sku.config && input.sku.config.inventory.use_serial || false,
        },
      },
      'skuId': input.sku && input.sku.sku_id,
      'skuCode': input.sku && input.sku.sku_code,
      'attributes': input.sku && input.sku.attributes,
      'barcode': input.sku && input.sku.barcode,
    },
    'product': {
      'productId': input.product && input.product.product_id,
      'productName': input.product && input.product.product_name,
      'unit': input.product && input.product.unit,
    },
    'warehouse': {
      'warehouseId': input.warehouse && input.warehouse.warehouse_id,
      'isDeleted': input.warehouse && input.warehouse.is_deleted,
      'warehouseName': input.warehouse && input.warehouse.warehouse_name,
      'shortName': input.warehouse && input.warehouse.short_name,
      'primary': input.warehouse && input.warehouse.primary,
      'info': {
        'address': input.warehouse && input.warehouse.info.address,
      },
      'binLocations': transformBins(input.warehouse && input.warehouse.bin_locations || []),
    },
    'lotId': input.lot_id,
  }
}

export const transformLots = (input = []) => {
  return input.map((item) => transformLot(item))
}

export default {
  namespaced: true,

  state: {
    lotList: transformLots([]),
    lotSingle: transformLot({}),
    lotLatestCode: null,
  },

  mutations: {
    setLotList (state, data) {
      state.lotList = transformLots(data)
    },
    setLotSingle (state, data) {
      state.lotSingle = transformLot(data)
    },
    setLotLatestCode (state, data) {
      state.lotLatestCode = data
    },
  },

  actions: {
    async getLotList ({ commit }, params = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getLotList') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getLotList')

        const response = await LotService.getLotList(params)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getLotList')

        result = response.data

        if (result.success) {
          commit('setLotList', result.data)
          this.dispatch('setPagination', result.meta)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getLotLatestCode ({ commit }, params) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getLotLatestCode') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getLotLatestCode')

        const response = await LotService.getLotLatestCode(params)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getLotLatestCode')

        result = response.data

        if (result.success) {
          commit('setLotLatestCode', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getLotSingle ({ commit }, id) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getLotSingle') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getLotSingle')

        const response = await LotService.getLotSingle(id)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getLotSingle')

        result = response.data

        if (result.success && result.data.length) {
          commit('setLotSingle', result.data[0])
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async createLot ({ commit }, data = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('createLot') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'createLot')

        const response = await LotService.createLot(data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'createLot')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async updateLot ({ commit }, { id, data = {} }) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('updateLot') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'updateLot')

        const response = await LotService.updateLot(id, data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'updateLot')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async updateLotStatus ({ commit }, { id, data = {} }) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('updateLotStatus') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'updateLotStatus')

        const response = await LotService.updateLotStatus(id, data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'updateLotStatus')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async deleteLot ({ commit }, id) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('deleteLot') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'deleteLot')

        const response = await LotService.deleteLot(id)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'deleteLot')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/Lot.js